import { highlight } from "@/assets/js/util";
import { qiniuImageURLPrefix } from "@/config/config";


// 定义过滤器函数

/**
 * 搜索结果高亮显示
 * @param {*} value 
 */
export const highLightWord = value => {
  if (!value) return ''
  let result = highlight(value)
  return result
}

/**
 * 绑定数据，若值为''等情况，渲染成‘未设置’
 * @param {*} value 
 */
export const getNullInfo = (value) => {
  if(value == "") {
    return '未设置'
  }
  return value
}

/**
 * 绑定数据，若值为''等情况，渲染成‘-’
 * @param {*} value 
 */
export const getNullVal = value => {
  if(value == "" || value == undefined) return '-'
  return value
}

/**
 * 绑定数据，将数字金额转为大写
 * @param {*} value 
 */
export const upMoney = n => {
  if(n == "") return ''
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "数据非法";
  let unit = "京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾元角分", str = "";
  n += "00";
  let p = n.indexOf('.');
  if (p >= 0)
      n = n.substring(0, p) + n.substr(p+1, 2);
  unit = unit.substr(unit.length - n.length);
  for (let i=0; i < n.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
  return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(兆|万|亿|元)/g, "$1").replace(/(兆|亿)万/g, "$1").replace(/(京|兆)亿/g, "$1").replace(/(京)兆/g, "$1").replace(/(京|兆|亿|仟|佰|拾)(万?)(.)仟/g, "$1$2零$3仟").replace(/^元零?|零分/g, "").replace(/(元|角)$/g, "$1整");
}


/**
 * 图片地址加前缀
 * @param {*} value 
 */
export const addImgPrefix = value => {
  if(!value) return ''
  return qiniuImageURLPrefix + value
}



//数字保留小数位数
export const numTofixed = (value) => {
  if(!/^\d+$/.test(value)){
    value = value.toFixed(2)
   }
  return value
}

// 是否为今天或明天
export const isToday = (value) => {
  let day1 = new Date();
  day1.setTime(day1.getTime());
  let s1_m = day1.getMonth()+1;
  let s1_d = day1.getDate();
  s1_m = s1_m>9?s1_m:'0'+s1_m;
  s1_d = s1_d>9?s1_d:'0'+s1_d;
  let s1 = day1.getFullYear()+"-" + s1_m + "-" + s1_d;

  let day2 = new Date();
  let s2_d = parseInt(day2.getDate());
  day2.setDate(s2_d+1);
  let s2_m = day2.getMonth()+1;
  s2_d = day2.getDate();
  s2_m = s2_m>9?s2_m:'0'+s2_m;
  s2_d = s2_d>9?s2_d:'0'+s2_d;
  let s2 = day2.getFullYear()+"-" + s2_m + "-" + s2_d;

  if(value == s1) {
    return '今天'
  }else if(value == s2) {
    return '明天'
  }else {
    return value;
  }
}

// 保留两位小数
export const toFix2 = (value) => {
  if(Number.isInteger(value) || isNaN(value)) {
    return value;
  }else {
    return value.toFixed(2);
  }
  
}

//处理多选框fliterData
export const dealFilterData = (data) => {
  let filterData = []
  for(const i in data){
    let arr = {}
    arr.id = i
    arr.name = data[i]
    filterData.push(arr)
  }
  return filterData
}

//处理时间格式
export const dealWithTime = (value, column) => {
  const realWidth = column.realWidth
  if(realWidth<170){
    value = value.split(' ')
    value = value[0]+'\n'+value[1]
  }
  return value
}